<template>
    <input
        class="form__input"
        @focusin="focusIn($event)"
        @focusout="focusOut($event)"
        v-model="model"
        :value="model || value"
        v-bind="$attrs"
        ref="input"
    />
</template>

<script lang="ts">
import { watchEffect } from "@vue/runtime-core";
import { Model, Options, Prop, Ref, Vue } from "vue-property-decorator";

@Options({
    emits: ["update:modelValue"],
})
export default class BaseInput extends Vue {
    @Ref()
    input!: HTMLInputElement;
    @Model("modelValue")
    model!: string;
    @Prop()
    value!: string;

    mounted() {
        if (this.input.value) {
            this.input.offsetParent!.classList.add("form__group--active");
        }

        watchEffect(() => {
            if (this.value || this.model) {
                this.input.offsetParent!.classList.add("form__group--active");
            }
        });
    }

    focusIn($event: Event) {
        const target = $event.target as HTMLInputElement;
        target.offsetParent!.classList.add("form__group--active");
    }

    focusOut($event: Event) {
        const target = $event.target as HTMLInputElement;
        if (target.value.length === 0) {
            target.offsetParent!.classList.remove("form__group--active");
        }
    }
}
</script>
